import { render, staticRenderFns } from "./ImsAddCustomerModal.vue?vue&type=template&id=2d07c4c8&"
import script from "./ImsAddCustomerModal.vue?vue&type=script&lang=js&"
export * from "./ImsAddCustomerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports